import { AlertDialog } from "./AlertDialog";
export type { AlertDialogProps } from "./AlertDialog";
export default AlertDialog;
